module.exports = __webpack_public_path__ + "public/images/search-icon.7c631208baa5218a92d377867540416f.svg";